import React, { useState } from 'react';
import { BirdzTitle } from '@applications-terrains/birdz-react-library';
import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FP2EAdditionalConfig from './FP2EAdditionalConfig';
import FP2EDiameters from './FP2EDiameters';
import FP2ESensorBrands from './FP2ESensorBrands';
import Reasons from './Reasons';
import PagePaper from '../../../Tools/Pages/PagePaper';

export default function ReferencesTables() {
  const [tab, setTab] = useState<number>(0);
  const { t } = useTranslation();
  const tabs = {
    0: t('referencesTables.fp2e.additionalConfigurations'),
    1: t('referencesTables.fp2e.diameters'),
    2: t('referencesTables.fp2e.sensorBrands'),
    3: t('referencesTables.reasons')
  };
  return (
    <PagePaper
      title={
        <>
          <BirdzTitle className="m-0">{t('referencesTables.referencesTables')}</BirdzTitle>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 1 }}>
            <Tabs
              value={tab}
              onChange={(_, newValueTab: number) => {
                setTab(newValueTab);
              }}
            >
              {Object.entries(tabs).map(([key, label]) => (
                <Tab key={key} label={label} />
              ))}
            </Tabs>
          </Box>
        </>
      }
      loader={false}
    >
      {tab === 0 && <FP2EAdditionalConfig />}
      {tab === 1 && <FP2EDiameters />}
      {tab === 2 && <FP2ESensorBrands />}
      {tab === 3 && <Reasons />}
    </PagePaper>
  );
}
